<app-column-title [column]="column"></app-column-title>

@if (rowHasData) {
  <div class="update-button">
    {{ getData }}
    <i class="table-col-icon fas fa-pen" (click)="onClick(btn)"></i>
  </div>
} @else {
  <div class="update-button">
    Add
    <i class="table-col-icon fas fa-plus-circle" (click)="onClick(btn)"></i>
  </div>
}
